import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';

import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';

const dragItemsSource = {
  beginDrag(props) {
    return { draggedIndex: props.itemIndex };
  },
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}
class DraggableTableRow extends Component {
  render() {
    const { connectDragSource, isDragging, label, value } = this.props;
    return connectDragSource(
      <div
        style={{
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: 'transparent',
        }}
      >
        <div className="table-td" title={label}>
          {label}
        </div>
        <div className="table-td" title={value.pct}>
          {value.pct}
        </div>
        <div className="table-td" title={value.incReach}>
          {value.incReach}
        </div>
        <div className="table-td" title={value.totalReach}>
          {value.totalReach}
        </div>
      </div>
    );
  }
}
DraggableTableRow.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
};

export default DragSource(
  DnDItemTypes.DnD_ITEM_TYPE_6,
  dragItemsSource,
  collect
)(DraggableTableRow);
